

import { motion, useScroll, useTransform } from "motion/react"
import {HTMLAttributes, useLayoutEffect, useRef, useState} from "react"


export default (props: HTMLAttributes<HTMLDivElement>) => {

  const ref = useRef<HTMLDivElement>(null);


  const [scale, setScale] = useState<number>(2);

  const fixedWidth = 400;

  useLayoutEffect(() => {
    if (!ref.current) return;

    const updateScale = () => {
      const el = ref.current;
      if (!el) {
        return;
      }

      setScale(el.offsetWidth / fixedWidth,);
    };

    updateScale();

    const observer = new ResizeObserver(updateScale);
    observer.observe(ref.current);

    return () => observer.disconnect();
  }, []);

  const [resetKey, setResetKey] = useState(0);

  // somehow maximum strokeWidth is 2?
  const strokeWidth = Math.min(2 / scale, 2);

  return <div {...props} ref={ref}>
    <motion.svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 482 92"
    width="100%"
    height="100%"
    initial="hidden"
    whileInView="visible"

    key={resetKey}
    onViewportLeave={() => setResetKey(k => k + 1)}

    >
      <motion.path
        d="M 0 92.289 C 35.713 73.234 68.114 65.885 102.113 65.449 C 136.112 65.013 181.287 84.366 222.381 83.066 C 263.475 81.766 296.523 69.848 300.085 41.759 C 303.647 13.67 252.181 21.264 261.507 50.89 C 270.833 80.516 315.421 82.263 341.322 81.134 C 367.223 80.005 434.284 68.792 482.122 0"
        fill="none"
        stroke="red"
        strokeWidth={strokeWidth}
        initial={{ pathLength: 0 }}
        whileInView={{ pathLength: 1 }}

        viewport={{
          once: false,
          amount: .9, // full visible

        }}

        transition={{
          duration: 1.8,
          ease: "easeInOut",
        }}
      />
    </motion.svg>
  </div>

}
